import AboutUs from 'Components/aboutUs/AboutUs';
import AnketaPage from 'Components/anketa';
import BlogPage from 'Components/blog/BlogPage';
import TermsOfUse from 'Components/contracts/TermsOfUse';
import ForJobseekers from 'Components/forJobseekers';
import { UserPage } from 'Components/home/UserPage';
import { RouteObject } from 'react-router-dom';
import { Questionary2025 } from './barometer/questionary2025';
import { FeatureForEmployers } from './feature-for-employers';

export const WEB_ROUTES: RouteObject[] = [
   {
      path: '/',
      Component: UserPage,
   },
   {
      path: '/aboutus',
      Component: AboutUs,
   },

   {
      path: '/anketa',
      Component: AnketaPage,
   },
   {
      path: '/terms-of-use',
      Component: TermsOfUse,
   },
   {
      path: '/foremployers',
      Component: FeatureForEmployers,
   },
   {
      path: '/forjobseekers',
      Component: ForJobseekers,
   },
   { path: '/blog', Component: BlogPage },
   {
      path: '/barometer-2025-questionnaire',
      Component: Questionary2025,
   },
];
